export enum CastorErrorCode {
  RECORD_ID_NOT_FOUND = 522,
  INSUFFICIENT_AUTHORIZATION = 1283
}
